import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

export type TooltipContainerElement = FlexElement;

export interface TooltipContainerProps extends FlexProps {}

export const TooltipContainer = styled(Flex).withConfig({
  displayName: 'TooltipContainer',
})`
  background-color: var(--spz-sys-color-surface-container);
  position: absolute;
  z-index: 2000;
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.2);
  border-radius: var(--shape-rounded-radius);
`;
